module.exports = __webpack_public_path__ + "assets/img/img-feature1-407db50a.jpg";